require('jquery.flot');

import {
  inToCm,
  cmToIn,
  daysBetween,
  mgompertz,
  mgompertz_inv,
  fgompertz,
  fgompertz_inv,
  getHCurve,
  xTickGenerator,
  getH,
  b,
  d,
  getAge,
} from 'packs/calculation.js'

var currentZoom = {xaxis: {from: 0, to: 24}};
var plot;
var puppyheightColor = '#599AC2';
var color2 = '#fc832f';
var color3 = '#e59e2e';
var color4 = '#fed83b';
var color5 = '#aeb23b';
var bgFill = 0.5;
var dogSizes = [
  {name: 'Giant', from: 50, to: 75, color: color5},
  {name: 'Large', from: 30, to: 50, color: color4},
  {name: 'Medium', from: 15, to: 30, color: color3},
  {name: 'Small', from: 5, to: 15, color: color2}
];

const MIN_STEP = 0;
const MAX_STEP = 720;
const STEP = 4.0;
let steps = [];
for (let i = MIN_STEP; i <= MAX_STEP; i += STEP) {
  steps.push(i);
}
var options = {
  // legend: { show: true, container: $("#legend") },
  legend: { show: false },
  xaxis: { ticks: xTickGenerator },
  yaxis: { ticks: 10, tickDecimals: 2, tickFormatter: function (tick) { return Math.round(tick*100)/100 + " " + $('#mixed_breed_puppy_height_height_unit').val(); } },
  selection: { mode: "xy" }
};
var datasetSizes = $.map(dogSizes, function(val, i) {
  var lower = getHCurve(steps, val.from);
  var upper = getHCurve(steps, val.to);
  var area = upper.reverse().concat(lower);
  return {label: val.name, data: area, lines: { show: true, lineWidth: 0.0, fill: bgFill}, color: val.color };
});
var bgData = datasetSizes;
var fgData = [];

function convertFromUnit(value) {
  if ($('#mixed_breed_puppy_height_height_unit').val() === 'in') {
    return inToCm(value);
  } else {
    return value;
  }
}

function convertToUnit(value) {
  if ($('#mixed_breed_puppy_height_height_unit').val() === 'in') {
    return cmToIn(value);
  } else {
    return value;
  }
}

function convertCurveToUnit(curve) {
  if ($('#mixed_breed_puppy_height_height_unit').val() === 'in') {
    for (let i = 0; i < curve.length; i++) {
      curve[i][1] = cmToIn(curve[i][1]);
    }
  }
}

export const drawPlot = function() {
  var dataset = bgData.concat(fgData);
  var croppedData = $.extend(true, [], dataset);
  if (typeof currentZoom.yaxis === "undefined") {
    var xmin = currentZoom.xaxis.min;
    var xmax = currentZoom.xaxis.max;
    for (let i = 0; i < dataset.length; i++) {
      for (let k = croppedData[i].data.length - 1; k >= 0; k--) {
        if ((croppedData[i].data[k][0] < xmin) || (croppedData[i].data[k][0] > xmax)) {
          croppedData[i].data.splice(k, 1);
        }
      }
    }
  }
  for (let k = 0; k < croppedData.length; k++) {
    convertCurveToUnit(croppedData[k].data);
  }
  plot = $.plot($("#placeholder"), croppedData, $.extend(true, {}, options, currentZoom));
  // $('#legend').find('table').addClass('condensed-table');
}

export const plotZoom = function(ranges) {
  currentZoom = {xaxis: { min: ranges.xaxis.from, max: ranges.xaxis.to }};
  if (typeof ranges.yaxis !== "undefined") {
    currentZoom = $.extend(true, currentZoom, {yaxis: { min: ranges.yaxis.from, max: ranges.yaxis.to }});
  }
  drawPlot();
}

function goToChart() {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#height-ans").offset().top - 160
  }, 350);
}

function getheight() {
  return convertFromUnit($('#mixed_breed_puppy_height_height').val());
}

export const validateInputs = function() {
  const age = getAge('#mixed_breed_puppy_height_birthdate', '#mixed_breed_puppy_height_measurement_date');

  if (age <= 0) {
    $('body').append("<div class='alert alert-dismissible fade show' role='alert'>You have entered an invalid input. Please check the summary to see what you have entered wrongly!<button aria-label='Close' class='btn-close' data-bs-dismiss='alert' type='button'></button></div>");
    return false;
  }

  const height = getheight();
  const w = getH(age, height);

  if (!$.isNumeric(w)) {
    $('body').append("<div class='alert alert-dismissible fade show' role='alert'>You have entered an invalid input. Please check the summary to see what you have entered wrongly!<button aria-label='Close' class='btn-close' data-bs-dismiss='alert' type='button'></button></div>");
    return false;
  }

  return true
}

export function updateAnswer() {
  const age = getAge('#mixed_breed_puppy_height_birthdate', '#mixed_breed_puppy_height_measurement_date');
  const height = getheight();
  const w = getH(age, height);

  if ($.isNumeric(w)) {
    $('#height-ans').text(convertToUnit(w).toFixed(1) + ' ' + $('#mixed_breed_puppy_height_height_unit').val());
    const puppyheight = getHCurve(steps, w);
    fgData = [
    { label: 'Your puppy', data: puppyheight, lines: { show: true, fill: false }, color: puppyheightColor },
    { data: [[age, height]], points: { show: true }, color: puppyheightColor }
    ];

    const from = inToCm(parseFloat($('#min').attr('data-value')));
    const to = inToCm(parseFloat($('#max').attr('data-value')));

    const lower = getHCurve(steps, from);
    const lowerLimit = getHCurve(steps, from * 0.7);
    const upper = getHCurve(steps, to);
    const upperLimit = getHCurve(steps, to  * 1.3);
    const area = upper.reverse().concat(lower);

    const underheightArea = lower.reverse().concat(lowerLimit);
    // reverse() is mutating, so upper has been reversed, cannot use
    const overheightArea = upperLimit.reverse().concat(getHCurve(steps, to));
    bgData = [
      { label: 'Your puppy', data: area, lines: { show: true, lineWidth: 0.0, fill: bgFill }, color: 'green' },
      { label: 'Overheight', data: overheightArea, lines: { show: true, lineWidth: 0.0, fill: bgFill }, color: 'red' },
      { label: 'Underheight', data: underheightArea, lines: { show: true, lineWidth: 0.0, fill: bgFill }, color: 'orange' },
    ];

    const eventualPuppyheight = puppyheight[puppyheight.length - 1][1]
    // lower and upper has been reversed, so take the first 1
    const eventualLowerLimit = lower[0][1]
    const eventualUpperLimit = upper[0][1]

    switch(true) {
      case eventualPuppyheight > eventualUpperLimit:
        $('#overheight-result').removeClass('d-none');
        $('.height-result').addClass('text-danger');
        $('#underheight-copy').hide();
        $('#non-underheight-copy').show();
        break
      case eventualPuppyheight < eventualLowerLimit:
        $('#underheight-result').removeClass('d-none');
        $('.height-result').addClass('text-warning');
        $('#underheight-copy').show();
        $('#non-underheight-copy').hide();
        break
      default:
        $('#healthy-result').removeClass('d-none');
        $('.height-result').addClass('text-success');
        $('#underheight-copy').hide();
        $('#non-underheight-copy').show();
    }

    drawPlot();
    $('.answer-container').slideDown(350);
    goToChart();
  } else {
    fgData = [];
    if ($('.flot-base').length !== 0) {
      drawPlot();
    };
    $('body').append("<div class='alert alert-dismissible fade show' role='alert'>You have entered an invalid input. Please check the summary to see what you have entered wrongly!<button aria-label='Close' class='btn-close' data-bs-dismiss='alert' type='button'></button></div>");
  }
}
